import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import TaxCalculatorInputs from 'TaxCalculator/components/TaxCalculatorInputs';

export default class TaxCalculator extends React.Component {
  static init(id, props) {
    ReactDOM.render(
      <TaxCalculator {...props} />,
      document.getElementById(id),
    );
  }

  constructor() {
    super();
    this.state = {
      income: 0,
      numChildren: 0,
      deduction: 0,
      credit: 0,
      savings: 0,
      calculated: false,
      isSingle: false,
    };
    this.updateIncome = this.updateIncome.bind(this);
    this.updateNumChildren = this.updateNumChildren.bind(this);
    this.updateFilingStatus = this.updateFilingStatus.bind(this);
    this.calculate = this.calculate.bind(this);
    this.getChildTaxCredit = this.getChildTaxCredit.bind(this);
    this.getFilerDeduction = this.getFilerDeduction.bind(this);

    this.MAX_SINGLE_INCOME = 200001;
    this.MAX_JOINT_INCOME = 400001;
    this.FILER_DEDUCTION = 0.2;
    this.CHILD_CREDIT = 2000;
  }

  getChildTaxCredit() {
    return this.CHILD_CREDIT * parseInt(this.state.numChildren, 10);
  }

  getFilerDeduction() {
    if (this.state.isSingle && this.state.income >= this.MAX_SINGLE_INCOME) {
      return 0;
    } else if (!this.state.isSingle && this.state.income >= this.MAX_JOINT_INCOME) {
      return 0;
    }
    return Math.ceil(this.FILER_DEDUCTION * this.state.income * 100) / 100;
  }

  updateIncome(e) {
    let income = Number(parseFloat(e.target.value).toFixed(2));
    if (isNaN(income)) {
      income = 0;
    }
    this.setState({
      income,
    });
  }

  updateNumChildren(e) {
    let numChildren = parseInt(e.target.value, 10);
    if (isNaN(numChildren)) {
      numChildren = 0;
    }
    this.setState({
      numChildren,
    });
  }

  updateFilingStatus(e) {
    let isSingle = !this.state.isSingle;
    const statusSelected = e.target.getAttribute('name');
    if (statusSelected === 'single' && this.state.isSingle) {
      return;
    } else if (statusSelected === 'joint' && !this.state.isSingle) {
      return;
    } else if (statusSelected === 'joint') {
      isSingle = false;
    }

    this.setState({
      isSingle,
    });
  }

  calculate() {
    const childTaxCredit = this.getChildTaxCredit();
    const filerDeduction = this.getFilerDeduction();
    this.setState({
      credit: childTaxCredit,
      deduction: filerDeduction,
      savings: childTaxCredit + filerDeduction,
      calculated: true,
    });
  }

  render() {
    const calculated = this.state.calculated ? 'calculated' : '';
    return (
      <div className="container tax-calculator-container">
        <div className="row">
          <div className="col-sm-12">
            <h1> Tax Calculator</h1>
          </div>
        </div>
        <TaxCalculatorInputs
          className="hidden-sm hidden-xs"
          updateIncome={this.updateIncome}
          updateNumChildren={this.updateNumChildren}
          calculate={this.calculate}
          isSingle={this.state.isSingle}
          updateFilingStatus={this.updateFilingStatus}
        />
        <div className="row">
          <div className="col-sm-12 col-md-8 col-md-offset-2">
            <img
              src={`${this.props.cdnURL}/images/tax-reform-guide/tax-calculator-2x.png`}
              alt="Tax Calculator"
            />
          </div>
        </div>
        <TaxCalculatorInputs
          className="hidden-md hidden-lg"
          updateIncome={this.updateIncome}
          updateNumChildren={this.updateNumChildren}
          calculate={this.calculate}
          isSingle={this.state.isSingle}
          updateFilingStatus={this.updateFilingStatus}
          mobile
        />
        <div className={`row tax-calculator-results ${calculated}`}>
          <div className="col-sm-12 col-md-4 deduction-col">
            <h3>Sole Proprietor Deduction</h3>
            <div className="calculator-result">
              <div className="float-left">$</div>
              {this.state.deduction}
            </div>
          </div>
          <div className="col-sm-12 col-md-4 credit-col">
            <h3>Child Tax Credit</h3>
            <div className="calculator-result">
              <div className="float-left">$</div>
              {this.state.credit}
            </div>
          </div>
          <div className="col-sm-12 col-md-4">
            <h3>Total Savings</h3>
            <div className="calculator-result">
              <div className="float-left">$</div>
              {this.state.savings}
            </div>
          </div>
        </div>
        <div className="row tax-calculator-sources">
          <div>
            Sources
            <sup>
              <a href="https://money.cnn.com/2017/12/15/news/economy/gop-tax-plan-details/index.html" target="_blank" rel="noopener noreferrer">
                18
              </a>
              <a href="https://www.moneyhelpcenter.com/taxes/calculate/2017-federal-income-tax-calculator/" target="_blank" rel="noopener noreferrer">
                19
              </a>
              <a href="https://www.taxreformcalculator.com/" target="_blank" rel="noopener noreferrer">
                20
              </a>
              <a href="https://www.calcxml.com/calculators/trump-tax-reform-calculator?skn=#results" target="_blank" rel="noopener noreferrer">
                21
              </a>
            </sup>
          </div>
        </div>
      </div>
    );
  }
}

TaxCalculator.propTypes = {
  cdnURL: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/TaxCalculator/index.jsx